import { bounceInOnEnterAnimation, bounceOutOnLeaveAnimation } from 'angular-animations';
import { Router, NavigationEnd } from '@angular/router';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, HostBinding, OnInit } from '@angular/core';
import { SaveSheetService } from '../../../services/save-sheet.service';
import { HeaderButton } from '../header-base/header-button/header-button.interface';
import { debounceTime } from 'rxjs';

@UntilDestroy()
@Component({
  selector: 'app-save-sheet',
  templateUrl: './save-sheet.component.html',
  styleUrls: ['./save-sheet.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  animations: [
    bounceInOnEnterAnimation({ delay: 400 }),
    bounceOutOnLeaveAnimation()
  ]
})
export class SaveSheetComponent implements OnInit, HeaderButton {
  @HostBinding('class.is-open')
  public isOpen = false;

  constructor(
    private saveSheetService: SaveSheetService,
    private router: Router,
    private cdr: ChangeDetectorRef,
  ) {
    this.router.events
      .pipe(untilDestroyed(this))
      .subscribe((e) => {
      if (e instanceof NavigationEnd) {
        this.saveSheetService.change(false);
      }
    });
  }

  public ngOnInit(): void {
    this.saveSheetService.openStatus$
      .pipe(untilDestroyed(this))
      .pipe(debounceTime(100))
      .subscribe((isOpen: boolean) => {
      this.isOpen = isOpen;
      this.cdr.markForCheck();
    });
  }

  public saveFormChanges(): void {
    this.saveSheetService.save();
  }
}
